module.exports = __webpack_public_path__ + "static/img/dog.901d7684.png";